import { render, staticRenderFns } from "./ProductComponentGroup.vue?vue&type=template&id=203e23bd&scoped=true"
import script from "./ProductComponentGroup.vue?vue&type=script&lang=js"
export * from "./ProductComponentGroup.vue?vue&type=script&lang=js"
import style0 from "./ProductComponentGroup.vue?vue&type=style&index=0&id=203e23bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203e23bd",
  null
  
)

export default component.exports